import { render } from "./SectionWidget.vue?vue&type=template&id=57c9b84b"
import script from "./SectionWidget.vue?vue&type=script&lang=js"
export * from "./SectionWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__